import { render } from "./LeaderboardList.vue?vue&type=template&id=6c283b46&scoped=true"
import script from "./LeaderboardList.vue?vue&type=script&lang=js"
export * from "./LeaderboardList.vue?vue&type=script&lang=js"

import "./LeaderboardList.vue?vue&type=style&index=0&id=6c283b46&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c283b46"]])

export default __exports__